export default {
    ABOUT_MY_DEVICE: 'aboutMyDevice',
    AEM_FLEX_BATTERY: 'aemFlexBattery',
    AEM_PAUSE_MODE: 'aemPauseMode',
    FLEX_PUFF: 'flexPuff',
    AUTO_START_MODE: 'autoStart',
    CLEANING_MODE: 'cleaning',
    CONNECT_CARE: 'connectCare',
    DEVICE_ADVANCED_DIAGNOSTIC: 'deviceAdvancedDiagnostic',
    DEVICE_RENAME: 'deviceRename',
    EXTENDED_LED_SETTING: 'extendedLedSetting',
    FWU_UPDATE_AVAILABLE: 'availableFwu',
    FWU_UPDATE_CHECK: 'checkFwu',
    GESTURE_MODE: 'gesture',
    GET_FEATURE_SECTION: 'getFeatureSection',
    LED_SETTING: 'ledSetting',
    LOCATE_MY_DEVICE: 'locateMyDevice',
    RESPONSIVE_DRAW: 'responsiveDraw',
    RESTART: 'restart',
    TNC_PREFERENCE_CENTER: 'tncPreferenceCenter',
    VAPE_CLOUD_SIZE: 'vapeCloudSize',
    VAPE_SESSION: 'vapeSession',
    VIBRATION_MODE: 'vibration',
    USAGE_MODE: 'usage',
};
